import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { Observable } from 'rxjs/Observable';
import { User } from '../model/user.class';
import { Media } from '../model/media.class';
import { OrganisationUnit } from '../model/organisationUnit.class';

@Component({
    selector: 'app-version-organisation-unit',
    templateUrl: './version.organisation.unit.component.html'
})
export class VersionOrganisationUnitComponent {

    @Input() organisationUnits: OrganisationUnit[];
    columns: Array<any> = [
        {
            title: 'Name',
            name: 'organisationUnitName',
            sort: '',
            filtering: { filterString: '', placeholder: 'Nach Name filtern' }
        },
        {
            title: 'Seitenzahl',
            name: 'pageNumber',
            sort: ''
        },
        {
            title: 'Kommentar',
            name: 'comment',
            sort: ''
        }
    ];

    constructor(public userService: UserService) { }
}



// WEBPACK FOOTER //
// ./src/app/versionOrganisationUnit/version.organisation.unit.component.ts